import { csx, Skeleton, Text } from '@vtex/admin-ui'
import type { ReactNode } from 'react'
import React from 'react'

import type { AvailabilityStatusIconProps } from './AvailabilityStatusIcon'
import { AvailabilityStatusIcon } from './AvailabilityStatusIcon'

export type ProductSkuAvailabilityRowProps = {
  icon: ReactNode
  title: ReactNode
  message: ReactNode
  status: AvailabilityStatusIconProps['status']
  rightColumn?: ReactNode
  busy: boolean | undefined
}

export const ProductSkuAvailabilityRow = ({
  icon,
  title,
  message,
  status,
  rightColumn,
  busy,
  ...props
}: ProductSkuAvailabilityRowProps) => (
  <div
    className={csx({
      display: 'grid',
      gridTemplateColumns: '24px 1fr auto',
      gap: '$space-5',
      alignItems: 'center',
      paddingY: '$space-5',
      ':not(:last-child)': {
        borderBottom: '$neutral',
      },
    })}
    {...props}
  >
    <div
      className={csx({
        display: 'flex',
        opacity: busy ? '0.2' : '1',
      })}
    >
      {icon}
    </div>
    <div>
      <Text variant="action1" className={csx({ display: 'block' })}>
        {title}
        {!busy && <AvailabilityStatusIcon status={status} />}
      </Text>
      <div>
        {busy ? (
          <Skeleton
            className={csx({
              width: '180px',
              height: '17.5px',
              marginTop: '6px',
            })}
          />
        ) : (
          <Text variant="action2" tone="secondary">
            {message}
          </Text>
        )}
      </div>
    </div>
    {!busy && rightColumn}
  </div>
)
